import { getPanneauxLcTlpe } from '@/api/PanneauxLc';

export default async function CalculTlpeLc(facNum, annee) {
  const response = await getPanneauxLcTlpe(facNum, annee);
  if (response === null) return 0;
  if (response.data.montantTLPE === null) return 0;
  const montant = Number(Math.round(response.data.montantTLPE + 'e' + 2) + 'e-' + 2);
  return montant;
}



// WEBPACK FOOTER //
// ./src/services/calcul/calculTlpeLc.js